import COLORS from 'assets/styles/colors';

import type { IIconProps } from 'infrastructure/interfaces';

const DisabledIcon = ({ color = COLORS.ROCKIN_RED, ...props }: IIconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_8735_197933)">
      <path
        d="M3.28634 3.28634L12.713 12.713M14.6663 7.99967C14.6663 11.6816 11.6816 14.6663 7.99967 14.6663C4.31778 14.6663 1.33301 11.6816 1.33301 7.99967C1.33301 4.31778 4.31778 1.33301 7.99967 1.33301C11.6816 1.33301 14.6663 4.31778 14.6663 7.99967Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8735_197933">
        <rect width="16" height="16" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default DisabledIcon;
